/**
 * A Promise that resolves when the DOMContentLoaded event fires or when the
 * document readyState is no longer 'loading'.
 *
 * This is useful in situations when code should execute as soon as it is loaded
 * and the DOM is ready, but won't be loaded before DOMContentLoaded event fires
 * (e.g. an js chunk loading aync).
 *
 * the DOMContentLoaded event only fires once. Any DOMContentLoaded event
 * listeners registered after the event fires will not be handled.
 *
 * Example:
 *
 * waitUntilReady.then(() => console.log("DOMContentLoaded!"));
 */
 const waitUntilReady = new Promise(resolve => {
  if (document.readyState !== 'loading') {
    resolve()
  } else {
    document.addEventListener('DOMContentLoaded', resolve)
  }
})

export default waitUntilReady
